import React, { useEffect } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import hcSwordImg from '../../../images/itemImg/hcbsword.jpg';

import { useRecoilState, useRecoilValue } from 'recoil';
import { bringItemState } from '../../../globalStates/item/bringItem';
import { itemData, itemIdToImg } from '../Item/manageItemData';
import { userDataState } from '../../../globalStates/general/userData';
import { useMedia } from 'use-media';

const ItemSelectArea = (props) => {
  const [bringItemId, setBringItemId] = useRecoilState(bringItemState);
  const userData = useRecoilValue(userDataState);
  const itemIdList = userData.itemList;
  const isPC = useMedia({ minWidth: '1000px' });
  let selectItemArea;

  const selectItemAreaWrap = css`
    display: ${props.fase === 1 ? "block" : "none"};
    text-align: center;
    h4 {
      margin-left: ${isPC ? "130px" : "0"};
    }
  `;


  if (isPC) {

    selectItemArea = css`
    margin: 16px 0;
    width: 30vw;
    height: auto;
    text-align: center;
    position: relative;

    .selectedItemArea{
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 70%;
      transform: translate(-50%, 0);
      width: 400px;
      height: 150px;
      border-radius: 10px;
    }
    .myItemArea {
      ::-webkit-scrollbar {
        width: 16px;
        height: 20px;
      }
      ::-webkit-scrollbar-track {
        background-color: #c8c6c6;
        padding: 0 10px;
      }
      ::-webkit-scrollbar-thumb {
        background: #6e6e6e;
        border: 3px solid #c8c6c6;
        border-radius: 20px;
        width: 130px;
        cursor: grab;
        :active {
          cursor: grabbing;
        }
      }
      border: 5px solid gray;
      overflow-x: scroll;
      overflow-y: hidden;
      width: 400px;
      height: 200px;
      padding-left: 30px;
      display: flex;
      align-items: center;
      position: absolute;
      left: 75%;
      top: -250px;
      transform: translate(-50%, 200%);
      background-color: #eaeaea;
      border-radius: 5px;
      p {
        text-align: center;
        color: #807e7e;
        font-size: 0.7em;
      }
      figure {
        cursor: pointer;
        box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .5);
        border-radius: 20px;
        overflow: hidden;
        width: 80px;
        height: 80px;
        margin-left: 15px;
        margin-right: 15px;
        background: #fff;

        position: relative;
      }
      figure::before {
        position: absolute;
        top: 0;
        left: -75%;
        z-index: 2;
        display: block;
        content: '';
        width: 50%;
        height: 100%;
        background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
        background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
        -webkit-transform: skewX(-25deg);
        transform: skewX(-25deg);
      }
      figure:hover::before {
        -webkit-animation: shine .75s;
        animation: shine .75s;
      }
      @-webkit-keyframes shine {
        100% {
          left: 125%;
        }
      }
      @keyframes shine {
        100% {
          left: 125%;
        }
      }

      .itemImgStyle {
        cursor: pointer;
        width: 80px;
        height: 80px;
        border-radius: 20px;
      }
      .selectedItem {
          display: flex;
          flex-flow: column;
          justify-content: center;
          position: relative;
          img {
            filter: grayscale(80%);
            cursor: pointer;
            width: 80px;
            height: 80px;
            border-radius: 20px;
            box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .5);
            margin-left: 15px;
            margin-right: 15px;
          }
          span {
            position: absolute;
            display: none;
          }
          :hover {
            span {
              top: -20px;
              left: 50%;
              transform: translate(-50%, 0%);
              display: block;
              color:#555555;
              font-size: 70%;
            }
          }
      }
    }
  `;
  } else {
    selectItemArea = css`
      display: flex;
      margin: 16px 0;
      width: 100vw;
      height: auto;
      text-align: center;
      position: relative;
      justify-content: center;
      align-items: center;

      .selectedItemArea{
        margin-top: 0px;
        transform: scale(0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        width: 400px;
        height: 150px;
      }
      .myItemArea {
        ::-webkit-scrollbar {
          width: 16px;
          height: 20px;
        }
        ::-webkit-scrollbar-track {
          background-color: #c8c6c6;
          padding: 0 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #6e6e6e;
          border: 3px solid #c8c6c6;
          border-radius: 20px;
          width: 130px;
          cursor: grab;
          :active {
            cursor: grabbing;
          }
        }
        border: 5px solid gray;
        overflow-x: scroll;
        overflow-y: hidden;
        width: 400px;
        height: 200px;
        padding-left: 30px;
        display: flex;
        align-items: center;
        transform: scale(0.8);
        background-color: #eaeaea;
        border-radius: 5px;
        p {
          text-align: center;
          color: #323232;
          font-size: 0.7em;
        }
        figure {
          cursor: pointer;
          box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .5);
          border-radius: 20px;
          overflow: hidden;
          width: 80px;
          height: 80px;
          margin-left: 15px;
          margin-right: 15px;
          background: #fff;

          position: relative;
        }
        figure::before {
          position: absolute;
          top: 0;
          left: -75%;
          z-index: 2;
          display: block;
          content: '';
          width: 50%;
          height: 100%;
          background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
          background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
          -webkit-transform: skewX(-25deg);
          transform: skewX(-25deg);
        }
        figure:hover::before {
          -webkit-animation: shine .75s;
          animation: shine .75s;
        }
        @-webkit-keyframes shine {
          100% {
            left: 125%;
          }
        }
        @keyframes shine {
          100% {
            left: 125%;
          }
        }

        .itemImgStyle {
          cursor: pointer;
          width: 80px;
          height: 80px;
          border-radius: 20px;
        }
        .selectedItem {
            display: flex;
            flex-flow: column;
            justify-content: center;
            position: relative;
            img {
              filter: grayscale(80%);
              cursor: pointer;
              width: 80px;
              height: 80px;
              border-radius: 20px;
              box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .5);
              margin-left: 15px;
              margin-right: 15px;
            }
            span {
              position: absolute;
              display: none;
            }
            :hover {
              span {
                top: -20px;
                left: 50%;
                transform: translate(-50%, 0%);
                display: block;
                color:#555555;
                font-size: 70%;
              }
            }
        }
      }




    `;
  }

  const itemEmpty = css`
    cursor: pointer;
    width: 80px;
    height: 80px;
    border-radius: 20px;
    box-shadow: 0 10px 25px 0 rgba(68, 68, 68, 0.5);
    outline: 1px dashed gray;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #555555;
    margin-left: 25px;
  `;

  const onAddItem = (itemId) => {
    if (bringItemId >= 3) return;
    if (bringItemId.includes(itemId)) {
      console.log("すでに追加されています。");
    } else if (bringItemId.includes(null)) {
      let tmpArr = [...bringItemId];
      const arrIndex = bringItemId.indexOf(null);
      tmpArr[arrIndex] = itemId;
      setBringItemId(tmpArr);
    }
  }
  const onCancelItem = (itemId) => {
    if (bringItemId.includes(itemId)) {
      let tmpArr = [...bringItemId];
      const arrIndex = bringItemId.indexOf(itemId);
      tmpArr[arrIndex] = null;

      setBringItemId(tmpArr);
    }
  }

  const restItemNum = () => {
    let cnt = 0;
    for (let i = 0; i < 3; i++) {
      if (bringItemId[i] === null) {
        cnt++;
      }
    }

    return cnt;
  }

  const bringItemStyle = css`
    img {
      width: 80px;
      height: 80px;
      border-radius: 20px;
      box-shadow: 0 10px 25px 0 rgba(68, 68, 68, 0.5);
    }
    p {
      text-align: center;
      margin-top: 5px;
      color: #807e7e;
      font-size: 0.7em;

    }
    margin-left: 25px;
    color: #555555;


  `;

  const createBringItemDom = () => {
    let contents = [];
    for (let i = 0; i < 3; i++) {
      if (bringItemId[i] != null) contents.push(<div css={bringItemStyle} key={"bring" + i} ><p>{itemData[bringItemId[i]].spendMp}</p><img src={itemIdToImg(bringItemId[i])}></img><p>{itemData[bringItemId[i]].name}</p></div>);
      else contents.push(<div css={itemEmpty} key={"bring" + i}>{i + 1}</div>)
    }
    return contents;
  }

  // データベースから受け取ったアイテムIdから表示させるhtmlを生成する。
  const createMyItemDom = (itemIdList) => {
    let contents = [];
    itemIdList.forEach((itemId) => {
      if (!bringItemId.includes(itemId)) contents.push(<div key={"notSelect" + itemId} onClick={() => onAddItem(itemId)} ><figure><img className="itemImgStyle" src={itemIdToImg(itemId)} key={"notSelect" + itemId} /></figure><p>{itemData[itemId].name}</p></div>);
      else contents.push(<div key={"div" + itemId} className="selectedItem"><span className='tooltip'>取り消す</span><img src={itemIdToImg(itemId)} onClick={() => onCancelItem(itemId)} /></div>)
    });
    return contents;
  }

  let bringItemsContents = createBringItemDom();
  let myItemsContents = createMyItemDom(itemIdList);
  useEffect(() => {
    bringItemsContents = createBringItemDom();
    myItemsContents = createMyItemDom(itemIdList);
  }, [bringItemId]);
  return (
    <>
      <div css={selectItemAreaWrap}>
        {restItemNum() > 0 ? (
          <h4>アイテムを{restItemNum()}つ選択してください</h4>
        ) :
          (<>
            <h4>アイテムの選択が完了しました</h4>
          </>)
        }
        <div css={selectItemArea}>
          <div className='selectedItemArea'>
            {bringItemsContents}
          </div>
          <div className='myItemArea'>
            {myItemsContents}
          </div>
        </div>
      </div>
    </>
  )
}

export default ItemSelectArea
